type ClsxValue = string | number | boolean | null | undefined | ClsxObject | ClsxValue[];
type ClsxObject = Record<string, unknown>;

export function clsx(...classNameValues: ClsxValue[]): string {
  let index = 0;
  let classNames = '';
  const totalValues = classNameValues.length;

  for (; index < totalValues; index += 1) {
    const classNameValue = classNameValues[index];

    if (!classNameValue) {
      continue;
    }

    const resolvedClassNames = toClassNameValue(classNameValue);

    if (resolvedClassNames === '') {
      continue;
    }

    if (classNames !== '') {
      classNames += ' ';
    }

    classNames += resolvedClassNames;
  }

  return classNames;
}

function toClassNameValue(classNameValue: ClsxValue): string {
  if (typeof classNameValue === 'string' || typeof classNameValue === 'number') {
    return String(classNameValue);
  }

  if (Array.isArray(classNameValue)) {
    let index = 0;
    let classNames = '';
    const totalValues = classNameValue.length;

    for (; index < totalValues; index += 1) {
      const nestedClassNameValue = classNameValue[index];

      if (!nestedClassNameValue) {
        continue;
      }

      const resolvedClassNames = toClassNameValue(nestedClassNameValue);

      if (resolvedClassNames === '') {
        continue;
      }

      if (classNames !== '') {
        classNames += ' ';
      }

      classNames += resolvedClassNames;
    }

    return classNames;
  }

  if (typeof classNameValue === 'object') {
    let classNames = '';

    for (const className in classNameValue) {
      if (!classNameValue[className]) {
        continue;
      }

      if (classNames !== '') {
        classNames += ' ';
      }

      classNames += className;
    }

    return classNames;
  }

  return '';
}
